(function () {
  'use strict'

  let forms = document.querySelectorAll('form')

  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      if (form.classList.contains('needs-validation')) {
        form.addEventListener('submit', function (event) {
          if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()

            form.classList.add('with-errors')
          } else {
            form.classList.remove('with-errors')
            var submits = form.querySelectorAll('[type=submit]')
            Array.prototype.slice.call(submits)
              .forEach(function(submit) {
                submit.innerHTML = 'Cargando ...'
                submit.disabled = true
              })
          }

          form.classList.add('was-validated')
        }, false)
      }
    })

  let alert_message = document.querySelector('.general-error-message')
  if (alert_message) {
    setTimeout(() => {
      alert_message.classList.add('closed')
      setTimeout(() => {
        alert_message.remove()
      }, 250)
    }, 5000)
  }

  let additional_support_btn = document.querySelector('.trigger-help-btn')
  if (additional_support_btn) {
    additional_support_btn.addEventListener('click', function (event) {
      event.preventDefault()
      let contact_form = document.querySelector('.contact-form')
      contact_form.classList.add('show')
    })
  }

  let support_btn = document.querySelector('.help-btn')
  if (support_btn) {
    support_btn.addEventListener('click', function (event) {
      event.preventDefault()
      let contact_form = document.querySelector('.contact-form')
      contact_form.classList.add('show')
    })
  }

  let close_support_btn = document.querySelector('.close-help-btn')
  if (close_support_btn) {
    close_support_btn.addEventListener('click', function (event) {
      event.preventDefault()
      let contact_form = document.querySelector('.contact-form')
      contact_form.classList.remove('show')
    })
  }
})()